import _ from 'lodash';

export default {
  name: 'pension-final-checks',
  data() {
    return {
      showPensionContributionsModal: false,
    };
  },
  computed: {
    getItem() {
      return _.cloneDeep(this.$store.getters['toolkit/getItemData']);
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    acknowledge: {
      get() {
        return this.getItem.pensions[this.activePension].finalChecks.acknowledge === true;
      },
      set(value) {
        this.setItem({ finalChecks: { acknowledge: value } });
      },
    },
  },
  methods: {
    setItem(data) {
      _.merge(this.pensions[this.activePension], data);
      this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: this.pensions } });
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  validations: {
    acknowledge: {
      mustBeTrue: value => value === true,
    },
  },
};
